<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Devices</a></li>
          <li><a>Assignments</a></li>
        </ul>
      </div>
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Device Assignments</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!responseLoader ? ngOnInit() : null"/>
        </div>

        <div class="assign-device-content-container">
          <div class="assign-device-card">
            <form role="form" name="addmapdevice" (ngSubmit)="getDevicesByselectedType()" novalidate>
              <div class="form-container row">
                <div class="col-xs-12 mb-15">
                  <div class="radio-field-wrapper">
                    <label class="radio-field-label">Select Device Type</label>
                    <mat-radio-group [(ngModel)]="customerDevice.selectedCMorFP" [ngModelOptions]="{standalone: true}" (change)="removetableData()" class="custom-radio-group">
                      <mat-radio-button value="1" class="margin-right-20">Continuous Water Monitoring</mat-radio-button>
                      <mat-radio-button value="0">Farm Provider</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                <div class="col-xs-12 text-right">
                  <div class="buttons-div reports_search_div" style="float: right;">
                    <div class="transactions-button-container" (click)="getDevicesByselectedType()">
                      <button type="submit" class="transaction-submit-button">
                        <span class="icon"><img src="assets/images/New_Icons/search-icon.svg"></span>
                        <span class="text">Search</span>
                      </button>
                    </div>
                  </div>
                </div>


              </div>
            </form>
          </div>

          <!-- Spinner loader -->
          <div *ngIf="!responseLoader" class="margin-top-20">
            <div class="adjust loader-container">
              <div class="loader2"></div>
            </div>
          </div>

          <!-- Results Table Card -->
          <div class="reports_block margin-top-20" *ngIf="responseLoader && isSearchclick">
            <div class="table-responsive" id="zoomView" *ngIf="displayDeviceDetails && displayDeviceDetails.length > 0">
              <table class="table table-striped table-bordered table-hover text-centre">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>DEVICE</th>
                    <th>FARM</th>
                    <th *ngIf="customerDevice.selectedCMorFP == '0'">MASTER</th>
                    <th *ngIf="customerDevice.selectedCMorFP == '0'">TRIAL</th>
                    <th>ASSIGN</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let list of displayDeviceDetails; let i = index">
                    <td>{{i + 1}}</td>
                    <td>{{list && list.device && list.device.number}}</td>
                    <td>{{list.businessName}}</td>
                    <td *ngIf="customerDevice.selectedCMorFP == '0'">{{list.isMaster == true ? 'Yes' : 'No'}}</td>
                    <td *ngIf="customerDevice.selectedCMorFP == '0'">{{list.isTrail == true ? 'Yes' : 'No'}}</td>
                    <td *ngIf="list.isAssigned && customerDevice.selectedCMorFP != '1'">{{list.isAssigned == true ? 'Already Assigned' : 'Click to assign'}}</td>
                    <td class="handSymbol" *ngIf="!list.isAssigned && customerDevice.selectedCMorFP != '1'"
                        (click)="navigateToAssignDeviceToFarm(list)">
                      {{list.isAssigned == true ? 'Already Assigned' : 'Click to assign'}}
                    </td>
                    <td class="handSymbol" *ngIf="customerDevice.selectedCMorFP == '1'"
                        (click)="navigateToAssignDeviceToFarm(list)">
                      Click to assign
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="(noList || !displayDeviceDetails || displayDeviceDetails.length === 0) && !listLoader" class="noDataFoundMessage">
              Devices are not available
            </div>
            <div *ngIf="listLoader" class="loader-div">
              <div class="adjust loader-container">
                <div class="loader2"></div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

